<template>
  <div class="hello">
    <p> 
      <img src="../assets/secaware-banner.png" height="70px" />
    </p>
    <!--p>
    <img src="../assets/secaware-logo.png" height="70px" />
    <span style="margin:140px"/>
    <img src="../assets/hgs.png" height="70px"/>
    </p-->
    <hr width="60%"/>
    <hr width="40%"/>
    <hr width="20%"/>
    <h1>  {{ msg }} </h1>
    <hr width="20%"/>
    <hr width="40%"/>
    <hr width="60%"/>

    <p>
      <input type="text" v-model="topic"
             placeholder="Dein Thema?" />
      <select name="anzahl" v-model="anzahl">
        <option v-for="i in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]"
                :value="i">{{ i }}</option>
      </select>
    <button v-on:click="dice()">Würfeln ...</button>
    <h2>{{ task }} {{ topic }}</h2>
    <ul>
      <li v-for="item in list">
        <img class="randimg"
             v-bind:src="'../static/images/' + item + '.svg'" 
             v-bind:alt="alt[item-1]"/>
      </li>
    </ul>
</div>
</template>
<script>
import 'vue-html-editor'

export default {
  name: 'stories',
  vueHtmlEditor: 'vue-html-editor',
  components: {},
  data () {
    return {
      msg: 'Story-Telling',
      task: 'Erzähl mir was zum Thema: ',
      topic: '',
      anzahl: 6,
      min: 1,
      max: 84,
      list: [],
      text: 'Hallo',
      alt: [
        ' Sprechblase mit Buchstabe "i". ',
        ' Flugzeug. ',
        ' grimmiges Gesicht. ',
        ' Apfel. ',
        ' Ritterhelm. ',
        ' Zelle in Pflanze oder Tier. ',
        ' Biene. ',
        ' Vogel. ',
        ' WLAN-Symbol. ',
        ' Mond und zwei Sterne. ',
        ' Käfer. ',
        ' Hochhaus. ',
        ' Kaktus. ',
        ' Fotoapparat. ',
        ' Zelt. ',
        ' Uhr. ',
        ' Clouns-Fisch. ',
        ' Krabbe. ',
        ' Krone. ',
        ' Baum. ',
        ' Würfel. ',
        ' @-Symbol. ',
        ' Facebook-Logo. ',
        ' Hand verdeckt Gesicht. ',
        ' Zauberstab. ',
        ' Haus in Flammen. ',
        ' Firewall für einen Computer. ',
        ' Taschenlampe. ',
        ' Kopf von der Seite mit Ausrufungszeichen darin. ',
        ' Springbrunnen. ',
        ' einzelne Flamme wie auf einer Kerze. ',
        ' Weltkugel. ',
        ' Alien. ',
        ' Haus. ',
        ' Python. ',
        ' Lampe angeschaltet. ',
        ' Selfie. ',
        ' Regenwolke. ',
        ' Schlüssel. ',
        ' Leiter im Schwimmbad. ',
        ' zwei Pyramiden und die Sonne. ',
        ' Pfleil nach links oben zeigend. ',
        ' Rettungsring. ',
        ' Blitz oder Strom. ',
        ' Tischlampe. ',
        ' Buch (aufgeschlagen). ',
        ' Vorhängeschloss geschlossen. ',
        ' Magnet. ',
        ' Baum mit Ring um dem Stamm. ',
        ' Noten (Musik). ',
        ' Oktopus. ',
        ' Fallschirm. ',
        ' Bohrmaschine. ',
        ' Büroklammer. ',
        ' Hand (alle fünf Finger gestreckt). ',
        ' Mütze (Polizei, Schaffner, Pilot, ...). ',
        ' Drucker. ',
        ' Puzzle-Teil. ',
        ' Fragezeichen. ',
        ' Smiley mit Fragezeichen. ',
        ' Fußabdruck. ',
        ' Frowny (trauriger Smiley. ',
        ' Balkenwaage. ',
        ' Bildschirm und Lupe. ',
        ' Lupe. ',
        ' Paragraph. ',
        ' Totenkopf. ',
        ' zwei Zahnräder. ',
        ' Schaf. ',
        ' Smiley --  gerader Mund. ',
        ' Axt/Beil. ',
        ' Sprechblase ohne Text. ',
        ' Hut, Maske und Stock. ',
        ' Komet. ',
        ' Erlenmeyerkolben. ',
        ' zwei Masken. ',
        ' japanisches Eingangstor. ',
        ' Smartfone. ',
        ' Karte mit Weg und Zielmarkierung. ',
        ' Schildkröte. ',
        ' Brille. ',
        ' Auge. ',
        ' Brücke. ',
        ' Krückstock. '
      ]
    }
  },
  methods: {
    dice: function () {
      this.list = []
      do {
        var x = Math.floor(Math.random() * (this.max - this.min + 1)) + this.min
        console.log(this.list.indexOf(x), this.list.length, x)
        if (this.list.indexOf(x) < 0) {
          this.list.push(x)
        }
      } while (this.list.length < this.anzahl)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.randimg {
  width: 100px;
}
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// Stories.vue?525899ac